import React from 'react';

import Button from '@asteria/component-core/button';
import Icon from '@asteria/component-core/icon';
import { Text, Title } from '@asteria/component-core/typography';

import { TranslationService } from '@asteria/language';

const SignupHero = () => {
	const handleEmailClick = React.useCallback(() => {
		const email = TranslationService.getV2([
			'auth.partner.swedbank.hero.email.contact',
		]);
		const subject = TranslationService.getV2([
			'auth.partner.swedbank.hero.email.subject',
		]);
		const body = TranslationService.getV2([
			'auth.partner.swedbank.hero.email.body',
		]);

		const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(
			subject,
		)}&body=${encodeURIComponent(body)}`;

		window.location.href = mailtoLink;
	}, []);

	return (
		<div className="asteria-component__hero">
			<Title size="lg">
				{TranslationService.getV2(['auth.partner.swedbank.hero.title'])}
			</Title>
			<Text size="lg">
				{TranslationService.getV2(['auth.partner.swedbank.hero.text'])}
			</Text>
			<ul className="asteria-component__unordered-list">
				<li className="asteria-component__unordered-list-item">
					<Icon icon="check" />
					<Text size="md">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.unordered-list-1.text',
						])}
					</Text>
				</li>
				<li className="asteria-component__unordered-list-item">
					<Icon icon="check" />
					<Text size="md">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.unordered-list-2.text',
						])}
					</Text>
				</li>
				<li className="asteria-component__unordered-list-item">
					<Icon icon="check" />
					<Text size="md">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.unordered-list-3.text',
						])}
					</Text>
				</li>
				<li className="asteria-component__unordered-list-item">
					<Icon icon="check" />
					<Text size="md">
						{TranslationService.getV2([
							'auth.partner.swedbank.hero.unordered-list-4.text',
						])}
					</Text>
				</li>
			</ul>
			<Text
				size="xs"
				className="asteria-component__typography--variant-italic"
			>
				{TranslationService.getV2([
					'auth.partner.swedbank.hero.disclaimer.text',
				])}
			</Text>

			<div className="asteria-component__buttons-container">
				<Button
					size="lg"
					label={TranslationService.getV2([
						'auth.partner.swedbank.hero.cta.label',
					])}
					variant="secondary"
					onClick={handleEmailClick}
				/>
				<Button
					size="sm"
					label={TranslationService.getV2([
						'auth.partner.swedbank.hero.external.label',
					])}
					variant="link"
					href={TranslationService.getV2([
						'auth.partner.swedbank.hero.external.url',
					])}
				/>
			</div>
		</div>
	);
};

export default SignupHero;
